// Module
var code = "<section> <cr-title-bar label=\"{{ ::$ctrl.text.contentStatus }}\" icon-class=\"icon-cr-info\"></cr-title-bar> <cr-tabs sticky-index=\"{{ ::$ctrl.crConstants.stickyZindex + 1 }}\"> <cr-tab label=\"{{ ::$ctrl.text.dashboard }}\" route-id=\"dashboard\"> <cr-cvt-dashboard></cr-cvt-dashboard> </cr-tab> </cr-tabs> </section> ";
// Exports
export default code;